import { Refresh } from "@mui/icons-material";
import { alpha, CircularProgress, IconButton } from "@mui/material";
import { TrendingUp } from "@raresail/react-ionicons";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { API_TRANSACTIONS } from "../../../constants/apis";
import { DIM_COLOR, primary5, PRIMARY_COLOR } from "../../../constants/colors";
import { COMPLETED, PENDING } from "../../../constants/constants";
import useGet from "../../../hooks/common/useGet";
import { useWallet } from "../../../hooks/wallets/useWallet";
import { useWalletBalance } from "../../../hooks/wallets/useWalletBalance";
import {
  updateGlobalContext,
  useGlobalContext,
} from "../../context/GlobalContext";
import { IconBox } from "../../elements/Elements";

export const BalanceCard = ({
  light = false,
  action,
  icon,
}: {
  light?: boolean;
  action?: { to?: string | any; label: string };
  icon?: any;
}) => {
  const { reload_transactions: pendingTransaction } = useGlobalContext();
  const { balance, currency, getWalletBalance, loading } = useWallet();
  const { to, label } = action || {};
  const { loadData: getTransaction } = useGet();

  const { toggleBalance, displayAmount, icon: Icon } = useWalletBalance();

  // const [showBalance, setShowBalance] = useState(false);
  // const toggleBalance = () => setShowBalance(!showBalance);
  // const displayAmount = showBalance
  //   ? numberFormat(parseInt(balance))
  //   : "********";

  // POLLING PENDING TRANSACTIONS
  useEffect(() => {
    if (pendingTransaction) {
      // if pending transaction is pending, poll for the transaction
      if (pendingTransaction?.status === PENDING) {
        let retryCount = 0;
        const MAX_RETRIES = 12; // 2 minutes total (12 * 10 seconds)

        const interval = setInterval(() => {
          if (retryCount >= MAX_RETRIES) {
            clearInterval(interval);
            updateGlobalContext({ pendingTransaction: null });
            return;
          }

          retryCount++;
          getTransaction({
            api: API_TRANSACTIONS,
            id: pendingTransaction.id,
            onSuccess: (data: any) => {
              // if transaction is completed, update the balance
              if (data.status === COMPLETED) {
                getWalletBalance();
              }
              // if transaction is not pending, stop polling
              if (data.status !== PENDING) {
                clearInterval(interval);
                updateGlobalContext({ pendingTransaction: null });
              }
            },
          });
        }, 10000); // Poll every 10 seconds

        return () => {
          clearInterval(interval); // Cleanup interval on unmount
        };
      }
    }
  }, [pendingTransaction]);

  return (
    <div
      className={`p20 r15 flexSpaceCenter gap20 ${
        light ? "whiteBg textDark" : "bgGradient white"
      }`}
    >
      <div>
        <div className={`font12 mb5 ${light && "grey"}`}>
          Wallet Balance <TrendingUp style={{ marginLeft: 5 }} />
        </div>
        <div className="flexNullCenter gap5">
          <div className="font18 bold">
            <span className="light">{currency}</span> {displayAmount(balance)}
          </div>
          {/* TOGGLE BALANCE */}
          <IconButton
            // size="small"
            sx={{
              color: light ? DIM_COLOR : "white",
              bgcolor: light ? primary5 : alpha("#fff", 0.1),
            }}
            onClick={toggleBalance}
          >
            <Icon fontSize="small" />
          </IconButton>

          {/* REFRESH BALANCE */}
          {loading ? (
            <CircularProgress
              sx={{ color: light ? PRIMARY_COLOR : "white", ml: "5px" }}
              size={18}
            />
          ) : (
            <IconButton
              size="small"
              sx={{ color: light ? DIM_COLOR : "white" }}
              onClick={() => getWalletBalance()}
            >
              <Refresh fontSize="small" />
            </IconButton>
          )}
        </div>
      </div>
      <div className="flexNullCenter gap10">
        {icon && <IconBox icon={icon} />}
        {action && (
          <Link to={to}>
            <div
              className="semiBold main whiteBg r20 font12 pointer animate textCenter capitalize"
              style={{ padding: "7px 16px" }}
            >
              {label}
            </div>
          </Link>
        )}
        {/* <Button
          onClick={() => {
            updateGlobalContext({
              pendingTransaction: {
                status: "pending",
                id: "9e1c2316-f4d1-485f-8be7-261659a284b2",
              },
            });
          }}
        >
          Add
        </Button> */}
      </div>
    </div>
  );
};
